import { apiRequest } from "./client";

export async function fetchTodos(year, month) {
  const response = await apiRequest(
    `/api/v1/todos?month=${encodeURIComponent(`${year}-${month}`)}`
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data && typeof data === "object" && "detail" in data && typeof data.detail === "string"
        ? data.detail
        : `HTTP ${response.status}`
    );
  }
  return data;
}

export async function resolveTodoIdByDate(scheduledOnYmd) {
  const response = await apiRequest(
    `/api/v1/todos/by-date/${encodeURIComponent(scheduledOnYmd)}`
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(
      data && typeof data === "object" && "detail" in data && typeof data.detail === "string"
        ? data.detail
        : `HTTP ${response.status}`
    );
  }
  return data;
}

export async function deleteTodo(todoPublicId) {
  try {
    const response = await apiRequest(`/api/v1/todos/${todoPublicId}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error(`削除に失敗しました: ${response.status}`);
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return await response.json();
    } else {
      return { success: true };
    }
  } catch (error) {
    console.error("Todo削除中にエラーが発生しました:", error);
    throw error;
  }
}
